
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/objects/[object]",
      function () {
        return require("private-next-pages/objects/[object]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/objects/[object]"])
      });
    }
  